<template>
  <div>
    <DataTable 
      :value="users"
      :paginator="true"
      :rows="20"
      :rowsPerPageOptions="[10, 20, 50, 100, 200]"
      :scrollable="true"
      :loading="loading"
      :filters="filters"
      
      class="p-datatable-sm"
      showGridlines
      responsiveLayout="scroll"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
      scrollHeight="400px"
      dataKey="id"
    >
      <template #header>
        <div class="d-flex justify-content-end">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" placeholder="Procurar..." />
            </span>
        </div>
      </template>
      <Column field="id" header="ID" :styles="{'min-width': '60px', 'max-width': '60px'}">
        <template #body="slotProps">
          <b>{{ slotProps.data.id }}</b>
        </template>
      </Column>
      <Column field="name" header="Nome" :styles="{'min-width': '230px'}"></Column>
      <Column field="email" header="E-mail" :styles="{'min-width': '230px'}"></Column>
      <Column field="is_admin" header="Tipo" :styles="{'min-width': '140px', 'max-width': '140px'}">
        <template #body="slotProps">
          <span v-if="slotProps.data.is_admin" class="badge text-bg-dark">Administrador</span>
          <span v-else>Usuário</span>
        </template>
      </Column>
      <Column field="active" header="Situação" :styles="{'min-width': '130px', 'max-width': '130px'}">
        <template #body="slotProps">
          <span v-if="slotProps.data.active" class="badge text-bg-success">Ativo</span>
          <span v-else class="badge text-bg-danger">Desativado</span>
        </template>
      </Column>
      <Column header="Ações" :styles="{'min-width': '210px', 'max-width': '210px'}">
        <template #body="slotProps">
          <div class="d-flex justify-content-around">
            <Button @click="openModalEdit(slotProps.data)" label="Editar" icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-sm p-button-primary" />
            <Button @click="openModalDelete(slotProps.data)" icon="pi pi-trash" label="Excluir" class="p-button-text p-button-rounded p-button-sm p-button-danger" />
          </div>
        </template>
      </Column>
    </DataTable>

    <ConfirmDialog></ConfirmDialog>
    <ModalEdit ref="modalEdit" />
    <ModalDelete ref="modalDelete" />
  </div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import ConfirmDialog from 'primevue/confirmdialog'
import ModalEdit from '@/components/pages/users/ModalEdit'
import ModalDelete from '@/components/pages/users/ModalDelete'
import InputText from 'primevue/inputtext'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'Table',

  props: ['users', 'loading'],

  components: {
    DataTable,
    Column,
    Button,
    ConfirmDialog,
    ModalEdit,
    ModalDelete,
    InputText
  },

  data() {
    return {
      filters: {},
    }
  },

  methods: {
    openModalEdit(data) {
      this.$refs.modalEdit.openModal(data)
    },

    openModalDelete(data) {
      this.$refs.modalDelete.openModal(data)
    },

    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    }
  },

  created() {
    this.initFilters();
  }
}
</script>

<style></style>